import { memo, useContext } from "react";

import { separateLineItems } from "@helpers/cart";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import LineItem from "./LineItem";

import { HandleType } from "@constants/HandleType";
import { GIFT_PACKAGES_HANDLES } from "@constants/GiftPackages";

import { CartContext } from "@context/CartProvider";
import { LUXE_GIFT_LINE_ITEM_ATTRIBUTE_KEY } from "@helpers/luxe";

function SideCartItems({ lineItems, toggleCart, freegiftLineItemId, isLuxe, onSwapGift }) {
  const { removeSingleProductsFromCart, removeManyProductsFromCart, updateCartNote } =
    useContext(CartContext);

  const { regularItems } = separateLineItems(lineItems);

  const sortedLineItems = [...regularItems].sort(
    (itemA, itemB) =>
      lineItems.findIndex((item) => item.id === itemA.id) -
      lineItems.findIndex((item) => item.id === itemB.id)
  );

  const removeItem = (lineItemId, lineItem) => {
    // Determine which lines should actually be removed from the cart.
    // If removing the specified lines would leave only gift package behind, remove it as well.
    const remainingLines = lineItems.filter(
      (line) => lineItemId !== line.id && line?.variant?.sku !== "L-0001"
    );
    const onlyGiftPackagesRemain =
      remainingLines.length > 0 &&
      remainingLines.every(
        (line) =>
          GIFT_PACKAGES_HANDLES.includes(line?.variant?.product?.handle) &&
          line.variant.sku !== "L-0001"
      );

    if (onlyGiftPackagesRemain) {
      removeManyProductsFromCart({ linesToRemove: [lineItem, ...remainingLines] });
      updateCartNote("");
    } else {
      removeSingleProductsFromCart({ lineToRemove: lineItem });
    }
  };

  return (
    <div>
      {sortedLineItems.map((lineItem) => {
        if (
          lineItem?.variant?.product?.handle === HandleType.ORDER_PROTECTION ||
          lineItem?.variant?.product?.handle === HandleType.SUBSCRIPTION ||
          lineItem?.attributes?.some(
            ({ key, value }) => key === LUXE_GIFT_LINE_ITEM_ATTRIBUTE_KEY && value === "true"
          )
        )
          return null;
        return (
          <div key={`side-cart-item--${lineItem.id}`} className="sidecart-item">
            <LineItem
              key={lineItem.id}
              lineItem={lineItem}
              toggleCart={toggleCart}
              onRemove={(lineItemId) => removeItem(lineItemId, lineItem)}
              isFreeGift={freegiftLineItemId && freegiftLineItemId === lineItem?.id}
              isLuxe={isLuxe}
              onSwapGift={onSwapGift}
            />
          </div>
        );
      })}
    </div>
  );
}

export default withALErrorBoundary({
  name: "SideCartItems",
  priority: "P1",
})(memo(SideCartItems));
